import {ICategoryItem} from "../interfaces/ICategoryItem";
import {EGeoType, ESource} from "../services/enumarations";

export const cats: ICategoryItem [] = [
    {
        label: 'VisitDenmark',
        color: '#cd2226',
        geotype: EGeoType.VDPoint,
        themes: [
            {category: 13, source: ESource.vd, type: EGeoType.VDPoint},
            {category: 16, source: ESource.vd, type: EGeoType.VDPoint},
            {category: 22, source: ESource.vd, type: EGeoType.VDPoint},
            {category: 23, source: ESource.vd, type: EGeoType.VDPoint},
            {category: 107, source: ESource.vd, type: EGeoType.VDPoint}
        ]
    },
    {
        label: 'Stier og ruter',
        label_de: 'Pfade und Routen',
        label_gb: 'Trails and routes',
        color: '#aaaaaa',
        geotype: EGeoType.Line,
        themes: [
            {category: 4, source: ESource.geofa, type: EGeoType.Line}
        ]
    },
    {
        label: 'Vandaktiviteter',
        label_de: 'Aktivitäten am Wasser',
        label_gb: 'Water activities',
        color: '#aaaaaa',
        geotype: EGeoType.Point,
        themes: [
            {category: 1051, source: ESource.geofa, type: EGeoType.Point},
            {category: 1062, source: ESource.geofa, type: EGeoType.Point}
        ]
    },
    {
        label: 'Friluftsaktiviteter',
        label_de: 'Outdooraktivitäten',
        label_gb: 'Outdoor activties',
        color: '#b20d0d',
        geotype: EGeoType.Point,
        themes: [
            {category: 1022, source: ESource.geofa, type: EGeoType.Point},
            {category: 1031, source: ESource.geofa, type: EGeoType.Point},
            {category: 1112, source: ESource.geofa, type: EGeoType.Point},
            {category: 1132, source: ESource.geofa, type: EGeoType.Point},
            {category: 4041, source: ESource.geofa, type: EGeoType.Point},
            {category: 1261, source: ESource.geofa, type: EGeoType.Point}
        ]
    },
    {
        label: 'P, WC og vand',
        label_de: 'P, WC und Trinkwasser',
        label_gb: 'P, WC and potable water',
        color: '#aaaaaa',
        geotype: EGeoType.Point,
        themes: [
            {category: 1012, source: ESource.geofa, type: EGeoType.Point},
            {category: 1122, source: ESource.geofa, type: EGeoType.Point},
            {category: 1162, source: ESource.geofa, type: EGeoType.Point},
            {category: 1712, source: ESource.geofa, type: EGeoType.Point},
            {category: 1182, source: ESource.geofa, type: EGeoType.Point},
            {category: 1222, source: ESource.geofa, type: EGeoType.Point}
        ]
    }
];
/*

 */
